import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabase";

export default function EmpresasAdmin() {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("pendente");

  useEffect(() => {
    fetchEmpresas();
  }, [filter]);

  const fetchEmpresas = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: queryError } = await supabase
        .from("empresas")
        .select("*")
        .eq("status", filter)
        .order("created_at", { ascending: false });

      if (queryError) {
        console.error("Erro ao buscar empresas:", queryError);
        setError(queryError.message);
        setEmpresas([]);
      } else {
        setEmpresas(data || []);
      }
    } catch (err) {
      console.error("Erro inesperado:", err);
      setError("Erro ao carregar dados");
      setEmpresas([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAprovar = async (id) => {
    await supabase.from("empresas").update({ status: "aprovado" }).eq("id", id);
    await logAction("aprovar_empresa", "empresa", id);
    fetchEmpresas();
  };

  const handleRejeitar = async (id) => {
    const motivo = prompt("Motivo da rejeicao:");
    if (motivo) {
      await supabase.from("empresas").update({ status: "rejeitado", motivo_rejeicao: motivo }).eq("id", id);
      await logAction("rejeitar_empresa", "empresa", id, motivo);
      fetchEmpresas();
    }
  };

  const logAction = async (acao, tipo, item_id, motivo = null) => {
    const { data: { session } } = await supabase.auth.getSession();
    if (session) {
      const { data: admin } = await supabase.from("admins").select("id").eq("user_id", session.user.id).single();
      if (admin) {
        await supabase.from("logs_admin").insert({ admin_id: admin.id, acao, tipo, item_id, motivo });
      }
    }
  };

  return (
    <div>
      <h1 style={{ fontSize: "1.5rem", fontWeight: "700", marginBottom: "1.5rem" }}>
        Empresas
      </h1>

      <div style={{ marginBottom: "1.5rem", display: "flex", gap: "0.5rem" }}>
        {["pendente", "aprovado", "rejeitado"].map((status) => (
          <button
            key={status}
            onClick={() => setFilter(status)}
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: filter === status ? "#3b82f6" : "#e5e7eb",
              color: filter === status ? "#fff" : "#374151",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              textTransform: "capitalize"
            }}
          >
            {status}
          </button>
        ))}
      </div>

      {loading ? (
        <p>Carregando...</p>
      ) : error ? (
        <p style={{ color: "#dc2626" }}>Erro: {error}</p>
      ) : empresas.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Nenhuma empresa {filter}.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {empresas.map((empresa) => (
            <div key={empresa.id} style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "1.5rem",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <h3 style={{ fontWeight: "600", marginBottom: "0.5rem" }}>{empresa.nome}</h3>
                  <p style={{ fontSize: "0.875rem", color: "#6b7280" }}>{empresa.email}</p>
                  <p style={{ fontSize: "0.875rem", color: "#6b7280" }}>{empresa.cidade}, {empresa.estado}</p>
                  {empresa.segmento && (
                    <p style={{ fontSize: "0.875rem", color: "#6b7280" }}>Segmento: {empresa.segmento}</p>
                  )}
                </div>
                {filter === "pendente" && (
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <button
                      onClick={() => handleAprovar(empresa.id)}
                      style={{
                        padding: "0.5rem 1rem",
                        backgroundColor: "#059669",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer"
                      }}
                    >
                      Aprovar
                    </button>
                    <button
                      onClick={() => handleRejeitar(empresa.id)}
                      style={{
                        padding: "0.5rem 1rem",
                        backgroundColor: "#dc2626",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer"
                      }}
                    >
                      Rejeitar
                    </button>
                  </div>
                )}
              </div>
              {empresa.motivo_rejeicao && (
                <p style={{ marginTop: "1rem", fontSize: "0.875rem", color: "#dc2626" }}>
                  Motivo: {empresa.motivo_rejeicao}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
